import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';

// This component is used to create a collapsable area where the
// first child wrapped by this component will be shown at first, and the rest will be shown when expanded

const CollapsableArea = props => {
    const [hidden, setHidden] = useState(true);
    const { children, showMoreText, showLessText, className } = props;
    const { isMobile } = useDeviceSize();

    const showMore = showMoreText || 'Vis mer';
    const showLess = showLessText || 'Vis mindre';

    return (
        <>
            {hidden ? children[0] : children}
            <button
                type="button"
                className={`button button--link font-bold ${className} ${isMobile ? 'mr-16' : ''}`}
                onClick={() => setHidden(!hidden)}
            >
                <p className="font-bold mb-0"> {hidden ? `+ ${showMore}` : `- ${showLess}`}</p>
            </button>
        </>
    );
};

CollapsableArea.propTypes = {
    children: PropTypes.array.isRequired,
    showMoreText: PropTypes.string,
    showLessText: PropTypes.string,
    className: PropTypes.string,
};

export default CollapsableArea;
